import React from 'react';
import { Redirect as RouterRedirect, useLocation } from 'react-router-dom';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';
import { isExternalUrl, redirect, getCombinedSearch, getPathWithTrailingSlash } from 'js/utils/url.util';

import { useGetPageRoutingURL } from 'js/hooks/useGetPageRoutingURL';

export const Redirect = (attribs) => {
    const toPage = attribs.to;
    const location = useLocation();
    const linkPath = useGetPageRoutingURL(toPage);
    const { useTrailingSlash } = useAppSelector(prop('seo'));

    if (isExternalUrl(toPage)) {
        redirect(toPage, attribs.isReplace);

        return null;
    }

    const link = new window.URL(linkPath, document.baseURI);
    const to = {
        state: location.state,
        pathname: getPathWithTrailingSlash(link.pathname, useTrailingSlash),
        search: getCombinedSearch(link.search, location.search),
        hash: link.hash
    };

    return <RouterRedirect {...attribs} to={to} />;
};
